import { Suspense, lazy } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { Button, EmptyState, PageHeader, Spinner } from '@luacentrix/ui';
import { ROUTES } from './app-nav';
import { AppShell } from './layouts/AppShell';
import { BlockedPage } from './pages/BlockedPage';

const OverviewPage = lazy(() =>
  import('./pages/OverviewPage').then(module => ({ default: module.OverviewPage })),
);
const ProjectsPage = lazy(() =>
  import('./pages/ProjectsPage').then(module => ({ default: module.ProjectsPage })),
);
const ScriptsPage = lazy(() =>
  import('./pages/ScriptsPage').then(module => ({ default: module.ScriptsPage })),
);
const ObfuscatorPage = lazy(() =>
  import('./pages/ObfuscatorPage').then(module => ({ default: module.ObfuscatorPage })),
);
const LicensesPage = lazy(() =>
  import('./pages/LicensesPage').then(module => ({ default: module.LicensesPage })),
);
const SecurityPage = lazy(() =>
  import('./pages/SecurityPage').then(module => ({ default: module.SecurityPage })),
);

function RouteFallback() {
  return (
    <div className="page-stack" role="status">
      <Spinner size="lg" />
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="page-stack">
      <PageHeader title="Page not found" description="No route is registered for this address." />
      <EmptyState
        icon="search"
        title="That page does not exist"
        description={`Registered pages: ${ROUTES.map(route => route.href).join(', ')}.`}
        action={
          <Link to="/">
            <Button variant="primary">Back to overview</Button>
          </Link>
        }
      />
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/blocked" element={<BlockedPage />} />
        <Route element={<AppShell />}>
          <Route index element={<OverviewPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="scripts" element={<ScriptsPage />} />
          <Route path="obfuscator" element={<ObfuscatorPage />} />
          <Route path="licenses" element={<LicensesPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
